/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".picker[_ngcontent-%COMP%]{display:inline-block;width:32px;height:32px;border-radius:50%;border:1px solid #6a82a4;background-color:transparent}.picker--small[_ngcontent-%COMP%]{width:24px;height:24px}.picker--large[_ngcontent-%COMP%]{width:48px;height:48px}"];
export { styles as styles };
